import React, { Component } from 'react';
import glamorous from 'glamorous';

import styles from './about.less';

import TextModule from './text-module';

const AboutPanel = glamorous.div({
  height: '350px',
});

const aboutStyle = {
  'high': `panel ${ styles['resize-about-high']}`,
  'mobile': `panel ${ styles['resize-about-mobile']}`,
  'regular': `panel ${ styles['about-regular']}`
};

export default class About extends Component {
  constructor(props) {
    super(props);
  }
  render() {
      return (
        <AboutPanel className={aboutStyle[this.props.aboutStyle]}>
          <TextModule
            title={this.props.title}
            content={this.props.content}
            align='left'
            textCenter={this.props.textCenter}
          />
        </AboutPanel>
      );
  }
}
